import React from 'react';

import { Price } from '../components/Price/Price';
import { useProductMetadata } from '../hooks/useProductMetadata';
import { useProductMetadataService } from '../services/useProductMetadataService';

export const PriceContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { discountInfo, productPrice, isVisibleDiscountDetailButton, priceInfo } = useProductMetadataService();
  const { displayPriceLine } = useProductMetadata();
  return (
    <Price
      productPrice={productPrice}
      discountInfo={discountInfo}
      displayPriceLine={displayPriceLine}
      isVisibleDiscountDetailButton={isVisibleDiscountDetailButton}
      onClickInfo={priceInfo.open}
    />
  );
};
